import { Node } from "../../graph/lib/node";
import { Grid } from "../../graph/lib/grid";
import { TreeNode } from "../lib/tree-node";

// deprecated
export class ColorTreeNode extends TreeNode {

    protected depth: number;
    protected static colorSpace: string = "white"

    constructor(rowIndex: number, colIndex: number, id: number, parent: TreeNode,
        colors: string[], allColors: string[], depth: number) {
        super(rowIndex, colIndex, id, parent, colors, allColors, depth);
    }


    draw(ctx: CanvasRenderingContext2D, grid: Grid) {

        const upperCornerLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        const x: number = upperCornerLeft[0];
        const y: number = upperCornerLeft[1];

        const width: number = grid.getWidthCell();
        const height: number = grid.getHeightCell();

        //Width of one compartiment
        const heightComp: number = height / this.depth;
        //Draw the outershape of the treenode
        ctx.save();
        ctx.beginPath();
        ctx.strokeStyle = this.currentColor;

        if(this.currentColor == this.selectColor){
            ctx.lineWidth = 6;
        }
        
        ctx.fillStyle = ColorTreeNode.colorSpace;
        ctx.strokeRect(x, y, width, height);
        ctx.fillRect(x + 1, y + 1, width - 2, height - 2);
        ctx.stroke();
        ctx.fill();
        ctx.closePath();
        ctx.restore();

        if (!this.hideContent) {
            let i = 0;
            for (i = 0; i < this.content.length; i++) {
                let compColor = this.content[i];
                ctx.save();
                ctx.beginPath();
                ctx.strokeStyle = this.currentColor;
                ctx.fillStyle = compColor;
                ctx.fillRect(x, y + heightComp * i, width, heightComp);
                ctx.stroke();
                ctx.fill();
                ctx.closePath();
                ctx.restore();
            }
        }else{
            let midX: number = (x + width/2);
            let midY: number = (y+height/2);

            ctx.fillText("?", midX,midY);
            ctx.textAlign = "center";
            ctx.fill();
            ctx.restore();
        }
    }

    inParameter(e: MouseEvent, grid: Grid): boolean {
        const upperCornerLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        const x: number = upperCornerLeft[0];
        const y: number = upperCornerLeft[1];

        const width: number = grid.getWidthCell()*1.5;
        const height: number = grid.getHeightCell()*1.5;

        let xInRange: boolean = (x <= e.offsetX && e.offsetX <= x+ width)
        let yInRange: boolean = (y <= e.offsetY && e.offsetY <= y + height);

        return xInRange && yInRange;

    }

    clone():Node{
        let cloneNode: ColorTreeNode = new ColorTreeNode(this.rowIndex,this.colIndex, this.id, this.parent, this.content, this.alphabet, this.depth);
        return cloneNode;
    }

}
